import { Outlet, useNavigate, Link } from "react-router-dom";
// Fix E (2026-09-04): sale Building2 (era el relleno cuando el cliente no cargó
// su logo); en su lugar va el isotipo de LOCCITEC.
import { LogOut, KeyRound } from "lucide-react";
import { IsotipoLoccitec } from "@/components/marca/LogoLoccitec";
import { usePortalAuth } from "@/lib/portalAuth";
import { PORTAL } from "@/constants/testIds";

export const PortalLayout = () => {
  const { cliente, logout } = usePortalAuth();
  const navigate = useNavigate();

  const salir = () => {
    logout();
    navigate("/portal/login");
  };

  return (
    <div className="min-h-screen bg-[var(--tc-surface)]">
      <header className="border-b border-[var(--tc-border)] bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4">
          <div className="flex items-center gap-3">
            {cliente?.logo_url ? (
              <img src={cliente.logo_url} alt={cliente.nombre} className="h-9 w-9 rounded-[var(--tc-radius)] object-contain" />
            ) : (
              <IsotipoLoccitec className="h-9 w-9 shrink-0" />
            )}
            <div className="leading-tight">
              <p data-testid={PORTAL.headerClienteName} className="text-[15px] font-semibold tracking-tight text-[var(--tc-text)]">
                {cliente?.nombre || "Portal de cliente"}
              </p>
              <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-[var(--tc-text-secondary)]">
                Torre de Control · LOCCITEC
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link
              data-testid={PORTAL.headerCuentaLink}
              to="/portal/cuenta"
              className="flex items-center gap-2 rounded-[var(--tc-radius)] px-3 py-2 text-sm font-medium text-[var(--tc-text-secondary)] transition-colors hover:bg-[var(--tc-accent-soft)] hover:text-[var(--tc-accent)]"
            >
              <KeyRound size={16} /> <span className="hidden sm:inline">Mi cuenta</span>
            </Link>
            <button
              data-testid={PORTAL.headerLogoutButton}
              onClick={salir}
              className="flex items-center gap-2 rounded-[var(--tc-radius)] px-3 py-2 text-sm font-medium text-[var(--tc-text-secondary)] transition-colors hover:bg-red-50 hover:text-red-600"
            >
              <LogOut size={16} /> <span className="hidden sm:inline">Cerrar sesión</span>
            </button>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
};
